import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { VehicleAttributeCategoryModel } from '../models/vehicleattributecategory.model';
import { VehicleAttributeCategoryService } from '../models/vehicleattributecategory.service';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, DataListModel, WeGoAuthorizedLink, PermissionType, Permission, RoleLevel } from '../../shared/config';


@Component({
  selector: 'wego-vehicleattributecategory-list',
  template: require('../views/vehicleattributecategory-list.component.html'),
  providers: [VehicleAttributeCategoryService]
})
export class VehicleAttributeCategoryListComponent implements OnInit {
  DataListModel: DataListModel;
  vehicleattributeCategoryList: VehicleAttributeCategoryModel[];
  apiErrorMsg: string;
  isLoading: boolean;
  urlVehicleAttributeCategoryAdd: string;
  urlVehicleAttributeCategoryUpdate: string;
  urlDefaultPage: string;
  private module: string;
  private breadCrumbList: string;
  addVehicleAttributeCategoryLink: WeGoAuthorizedLink;
  roleLevel = RoleLevel;
  
  constructor(private vehicleattributeCategoryService: VehicleAttributeCategoryService,
    private authService: AuthService,
    private router: Router, private translate: TranslateService) {
  }

  ngOnInit() {
    this.breadCrumbList = this.translate.instant('LblVehicleAttributeCategory', [this.module]);
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    if(this.authService.GetHighestRoleLevel() <= this.roleLevel.Instance){
      this.DataListModel.searchField = ["instanceName", "vehicleAttributeCategoryName"];
    }else{
      this.DataListModel.searchField = [ "vehicleAttributeCategoryName"];
    }
    
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlVehicleAttributeCategoryAdd = this.authService.GetURL(ApplicationRouteURL.URL_VEHICLEATTRIBUTE_CATEGORY_ADD);
    this.urlVehicleAttributeCategoryUpdate = this.authService.GetURL(ApplicationRouteURL.URL_VEHICLEATTRIBUTE_CATEGORY_UPDATE);
    this.GetVehicleAttributeCategoryList();
    this.addVehicleAttributeCategoryLink = new WeGoAuthorizedLink(this.urlVehicleAttributeCategoryAdd,
      Permission.PR_VEHICLE_ATTRIBUTE_CATEGORIES, PermissionType.INSERT, 'btn btn-highlight navbar-right', 'LblAddNew');
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetVehicleAttributeCategoryList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
    this.GetVehicleAttributeCategoryList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetVehicleAttributeCategoryList();
  };

  public OnPagingChange(event: any) {
    console.log(this.DataListModel);
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetVehicleAttributeCategoryList();
  }
  public OnExport(event: any) {
    this.isLoading = true;
    this.vehicleattributeCategoryService.ExportVehicleAttributeCategoryList(this.DataListModel)
      .subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "VehicleAttribute" + new Date().toISOString() + ".csv";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });;
  }

  public GetVehicleAttributeCategoryList() {
    this.isLoading = true;
    this.vehicleattributeCategoryService.GetVehicleAttributeCategoryList(this.DataListModel)
      .subscribe(
      res => {
        this.vehicleattributeCategoryList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }
  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/vehicle-attribute-category/components/vehicleattributecategory-list.component.ts